import config from '@/config';
import {ApiBase} from '@/api/common';
import Topic from '@/api/topic';
import School from '@/api/school';

const NO_UPLOAD_FIELDS = [
    'is_staff',
];

export default class User extends ApiBase<Topic> {
    public static readonly SLUG: string = 'user';
    private static readonly URL_BASE: string = config.API_ROOT + '/user/';
    
    // Initializing these fields (even with undefined)
    // is necessary, so hasOwnAttribute can find them.
    public username?: string = undefined;
    public email?: string = undefined;
    public is_staff?: boolean = undefined;
    public schools?: ApiBase<School> = undefined;
    
    public constructor() {
        super({
            urlBase: User.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }
    
    public static async get(): Promise<User> {
        return this.doGet({
            urlBase: User.URL_BASE,
            id: null,
            create: (response) => new User().assign(response),
        });
    }
}
